<script>
export default {
  name: 'DescriptionWYSIWYG',
  props: {
    description: {
      type: String
    },
  }
}
</script>

<template>
  <div class="one-office-information-wrapper" v-html="description"></div>
</template>

<style lang="scss" scoped>
.one-office-information-wrapper {
  padding: 20px;
  background: $color-grey;
  border-radius: 30px;
  font-size: $paragraph-1;
  color: $color-brown;
  max-width: 100%;
  overflow: hidden;
  word-break: break-word;

  img {
    max-width: 100%;
    height: auto; /* Ensure the height is adjusted automatically */
    object-fit: contain; /* Scale the image to fill the container */
    display: block; /* Remove bottom space of inline images */
  }

  figure {
    margin: 0; /* Remove default margins */
    padding: 0; /* Remove default paddings */
    max-width: 100%; /* Ensure figure does not exceed container width */
    overflow: hidden; /* Prevent overflow */

    picture {
      display: block; /* Ensure picture behaves like a block element */
      max-width: 100%; /* Ensure picture does not exceed container width */
      overflow: hidden; /* Prevent overflow */


    }

    figcaption {
      font-size: $paragraph-1; /* Adjust as needed */
      color: $color-brown; /* Match the text color */
      text-align: center; /* Center the caption text */
    }
  }
}

@media screen and (min-width: 768px) {
  .one-office-information-wrapper {
    padding: 120px 250px;
  }
}
</style>

